import React from 'react'

const RegionManagerMenu: React.FC = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      width="32"
      height="32"
      rx="6.64935"
      fill="url(#paint0_linear_4949_40951)"
      fillOpacity="0.1"
    />
    <path
      d="M16.0066 17.9733C16.4673 17.6277 16.8992 17.2534 17.3599 16.9079C17.4463 16.8503 17.5326 16.7928 17.5902 16.7064C17.8206 16.4472 18.0797 16.4184 18.3964 16.5336C19.7209 16.9367 20.959 17.4838 22.0243 18.4051C22.8593 19.125 23.4064 20.0175 23.6079 21.1404C23.6943 21.6587 23.5503 22.033 23.1184 22.3209C22.0819 23.012 20.9302 23.3863 19.7209 23.6454C17.9933 23.9909 16.237 24.0773 14.4806 23.9333C12.897 23.8182 11.3134 23.5302 9.84501 22.8392C9.55708 22.724 9.24036 22.5513 8.95244 22.3785C8.43417 22.0618 8.29021 21.6875 8.40538 21.0829C8.63572 19.8736 9.32674 18.9522 10.2769 18.2036C11.3422 17.3686 12.5803 16.8503 13.876 16.5048C13.9624 16.476 14.1063 16.5336 14.1927 16.5912C14.7398 17.0231 15.2868 17.455 15.8339 17.8869C15.8915 17.8869 15.9491 17.9445 16.0066 17.9733ZM16.0354 18.0884C16.0066 18.0884 16.0066 18.0884 15.9778 18.0884C15.7475 19.0098 15.5172 19.9024 15.258 20.8237C15.1429 21.2556 15.1717 21.5723 15.4308 21.9178C15.6323 22.2058 15.8051 22.4937 16.0066 22.8392C16.3234 22.3497 16.2946 22.4361 16.5249 21.9466C16.6689 21.6875 16.9568 21.3708 16.7552 20.7086C16.5825 20.0751 16.5537 19.9887 16.3809 19.3553C16.2658 18.9522 16.1506 18.5203 16.0354 18.0884Z"
      fill="#052351"
    />
    <path
      d="M16.0354 16.0442C14.5958 15.9866 13.5017 15.3532 12.7819 14.1439C11.8029 12.5603 12.0621 10.4296 13.3865 9.10515C14.8837 7.60793 17.2447 7.63672 18.7132 9.16274C20.7286 11.2646 19.9512 14.8349 17.2447 15.8138C17.072 15.8714 16.8992 15.929 16.6977 15.9578C16.4673 16.0154 16.237 16.0154 16.0354 16.0442Z"
      fill="#052351"
    />
    <defs>
      <linearGradient
        id="paint0_linear_4949_40951"
        x1="15.7922"
        y1="0"
        x2="15.7922"
        y2="32"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0062FF" />
        <stop offset="1" stopColor="#004BC2" />
      </linearGradient>
    </defs>
  </svg>
)

export default RegionManagerMenu
